// 等级管理
import http from "@/jslibs/axios/http";

// 等级列表
export const list = (data) => http.get(`/v1/cms/UserLevel`, data);

// 等级新增
export const add = (data) => http.post(`/v1/cms/UserLevel`, data);

// 等级编辑
export const edit = ({ uuid, ...data }) => http.put(`/v1/cms/UserLevel/${uuid}`, data);

// 等级删除
export const del = (data) => http.delete(`/v1/cms/UserLevel/${data.uuid}`);

// 等级详情
export const detail = (data) => http.get(`/v1/cms/UserLevel/${data.uuid}`);
